import { ShieldCheck } from "lucide-react";
import { LegalPageShell } from "@/components/legal/LegalPageShell";

// Página pública. Accesible SIN sesión. Ruta declarada en App.js: /aviso-privacidad.
// Oct-2026 · Aviso de Privacidad INTEGRAL (texto legal completo proporcionado por el
// product owner, versión 2026-10-16). Reemplaza al aviso simplificado anterior.
// NO modificar el texto sin autorización del PO.
export default function AvisoPrivacidad() {
  return (
    <LegalPageShell
      testId="aviso-privacidad-page"
      icon={<ShieldCheck className="h-5 w-5 text-primary" />}
      kicker="Protección de datos personales"
      titulo="Aviso de Privacidad Integral">
      <p className="text-sm leading-relaxed text-slate-700">
        <b>Servicios Legales y Fiscales BLC, S.C.</b>, que opera la plataforma <b>FELVORA</b>, es
        responsable del tratamiento de los datos personales de quienes contratan y usan la
        plataforma, conforme a la Ley Federal de Protección de Datos Personales en Posesión de
        los Particulares.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        1. Identidad y domicilio del responsable
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Servicios Legales y Fiscales BLC, S.C. (en adelante, "FELVORA"), con RFC SLF251209LRA, es
        la responsable del tratamiento de sus datos personales.
      </p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full border-collapse text-sm" data-testid="aviso-tabla-responsable">
          <tbody>
            <tr className="border-b border-slate-200">
              <td className="w-40 py-2 pr-3 align-top font-semibold text-slate-700">Domicilio</td>
              <td className="py-2 text-slate-700">
                Avenida Tlaxcala Sur 36 B, entre Av. Álamos y Carretera Federal, Papalotla,
                Municipio de Papalotla de Xicohténcatl, Tlaxcala, C.P. 90790
              </td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Correo para datos personales
              </td>
              <td className="py-2 text-slate-700">contacto@felvora.mx</td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">Teléfono</td>
              <td className="py-2 text-slate-700">221 573 4295</td>
            </tr>
            <tr>
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Área responsable
              </td>
              <td className="py-2 text-slate-700">Dirección General</td>
            </tr>
          </tbody>
        </table>
      </div>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        2. Datos personales que tratamos
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Tratamos los datos de los representantes, usuarios y oficiales de cumplimiento de las
        entidades que contratan FELVORA.
      </p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full border-collapse text-sm" data-testid="aviso-tabla-datos">
          <tbody>
            <tr className="border-b border-slate-200">
              <td className="w-40 py-2 pr-3 align-top font-semibold text-slate-700">
                Identificación
              </td>
              <td className="py-2 text-slate-700">
                Nombre, puesto, firma electrónica o autógrafa, identificación oficial cuando se
                requiera
              </td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">Contacto</td>
              <td className="py-2 text-slate-700">Correo electrónico, teléfono, domicilio</td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Fiscales y patrimoniales
              </td>
              <td className="py-2 text-slate-700">
                RFC, denominación o razón social, régimen y domicilio fiscal contenidos en la
                Constancia de Situación Fiscal; datos de facturación y pago
              </td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">Laborales</td>
              <td className="py-2 text-slate-700">
                Entidad a la que pertenece, cargo y rol dentro de la plataforma
              </td>
            </tr>
            <tr>
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Uso de la plataforma
              </td>
              <td className="py-2 text-slate-700">
                Credenciales de acceso, dirección IP, fecha y hora de acceso, bitácora de acciones
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        FELVORA no solicita datos personales sensibles como responsable. Los datos de pago con
        tarjeta los procesa directamente el proveedor de pagos; FELVORA no almacena el número
        completo de la tarjeta. Al tratarse de datos fiscales y patrimoniales, solicitamos su
        consentimiento expreso, que usted otorga al marcar la casilla de aceptación de este
        aviso.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        3. Finalidades del tratamiento
      </h2>
      <p className="mt-2 text-sm font-semibold text-slate-800">
        Finalidades primarias, necesarias para la relación con usted:
      </p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>Validar la identidad de la entidad, de sus representantes y de sus usuarios.</li>
        <li>Dar de alta, administrar y proteger las cuentas de acceso a la plataforma.</li>
        <li>Prestar los servicios contratados, incluido el soporte técnico.</li>
        <li>Facturar, cobrar y administrar la suscripción.</li>
        <li>
          Mantener bitácoras de seguridad y de uso, y prevenir accesos no autorizados o fraudes.
        </li>
        <li>Cumplir obligaciones legales y atender requerimientos de autoridades competentes.</li>
      </ul>
      <p className="mt-3 text-sm font-semibold text-slate-800">
        Finalidades secundarias, que no son necesarias para el servicio:
      </p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>
          Enviar información sobre nuevas funciones, cursos, eventos y servicios de FELVORA.
        </li>
        <li>Realizar encuestas de satisfacción y estudios para mejorar la plataforma.</li>
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        Si no desea que sus datos se usen para las finalidades secundarias, escriba a
        contacto@felvora.mx con el asunto "Negativa finalidades secundarias". Su negativa no
        afecta los servicios contratados.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        4. Datos de los clientes de cada entidad: FELVORA como encargado
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Los datos de prospectos, clientes, acreditados, integrantes, beneficiarios y demás
        personas que cada entidad captura en la plataforma son responsabilidad de esa entidad.
        Respecto de esos datos, FELVORA actúa únicamente como encargado.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">Como encargado, FELVORA:</p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>
          Trata esos datos solo conforme a las instrucciones de la entidad y al contrato de
          prestación de servicios.
        </li>
        <li>
          No los usa para fines propios ni los comparte con terceros, salvo con los proveedores
          necesarios para operar la plataforma o por requerimiento de autoridad.
        </li>
        <li>
          Mantiene separada la información de cada entidad y restringe el acceso de su personal
          a esos datos.
        </li>
        <li>
          Los devuelve o suprime al terminar el contrato, en los términos pactados y sin
          perjuicio de los plazos de conservación que la ley imponga a la entidad.
        </li>
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        Los titulares de esos datos deben dirigir sus solicitudes de acceso, rectificación,
        cancelación u oposición directamente a la entidad con la que tienen relación, conforme al
        aviso de privacidad de esa entidad.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        5. Remisiones y transferencias
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Para operar la plataforma, FELVORA comunica datos a proveedores que los tratan por su
        cuenta y bajo su instrucción (remisiones), sin que se requiera su consentimiento:
      </p>
      <div className="mt-3 overflow-x-auto">
        <table className="w-full border-collapse text-sm" data-testid="aviso-tabla-proveedores">
          <tbody>
            <tr className="border-b border-slate-200">
              <td className="w-56 py-2 pr-3 align-top font-semibold text-slate-700">
                Hospedaje e infraestructura en la nube
              </td>
              <td className="py-2 text-slate-700">
                Almacenar la información y operar la plataforma
              </td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Envío de correo electrónico
              </td>
              <td className="py-2 text-slate-700">
                Enviar notificaciones, verificaciones de cuenta y avisos del sistema
              </td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Procesamiento de pagos
              </td>
              <td className="py-2 text-slate-700">Cobrar la suscripción</td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Proveedor autorizado de certificación (PAC)
              </td>
              <td className="py-2 text-slate-700">Emitir comprobantes fiscales digitales</td>
            </tr>
            <tr className="border-b border-slate-200">
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Consulta de listas de prevención de lavado de dinero
              </td>
              <td className="py-2 text-slate-700">
                Verificar a las personas contra listas, cuando la entidad lo solicita
              </td>
            </tr>
            <tr>
              <td className="py-2 pr-3 align-top font-semibold text-slate-700">
                Verificación anti-bots
              </td>
              <td className="py-2 text-slate-700">
                Proteger el registro y el acceso contra ataques automatizados
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        FELVORA solo transfiere datos sin su consentimiento en los casos que permite la Ley,
        entre ellos cuando lo ordena una autoridad competente o cuando es necesario para cumplir
        una obligación legal. No vendemos ni cedemos datos personales a terceros.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        6. Derechos ARCO, revocación y limitación del uso
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Usted puede acceder a sus datos, rectificarlos, cancelarlos u oponerse a su tratamiento
        (derechos ARCO), así como revocar su consentimiento, enviando una solicitud a{" "}
        <a
          href="mailto:contacto@felvora.mx"
          className="font-medium text-accent hover:underline"
          data-testid="aviso-arco-email">
          contacto@felvora.mx
        </a>{" "}
        que contenga:
      </p>
      <ul className="mt-2 list-disc space-y-1 pl-5 text-sm leading-relaxed text-slate-700">
        <li>Su nombre y un medio para comunicarle la respuesta.</li>
        <li>
          Copia de su identificación oficial o, en su caso, el documento que acredite la
          representación.
        </li>
        <li>La descripción clara de los datos y del derecho que desea ejercer.</li>
        <li>
          En caso de rectificación, el dato correcto y, si aplica, el documento que lo respalde.
        </li>
      </ul>
      <p className="mt-3 text-sm leading-relaxed text-slate-700">
        FELVORA le responderá dentro de los plazos que establece la Ley. La revocación del
        consentimiento para finalidades primarias puede implicar que no podamos seguir prestando
        el servicio. Para limitar el uso o divulgación de sus datos, por ejemplo para dejar de
        recibir información comercial, escriba al mismo correo o use la opción para darse de baja
        incluida en cada comunicación.
      </p>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        7. Cookies, seguridad y conservación
      </h2>
      <ul className="mt-2 space-y-2 text-sm leading-relaxed text-slate-700">
        <li>
          <b>Cookies y tecnologías similares.</b> La plataforma usa cookies y almacenamiento del
          navegador necesarios para mantener su sesión, recordar preferencias y proteger el
          acceso, incluida la verificación anti-bots. No las usamos para publicidad. Puede
          deshabilitarlas en su navegador, aunque la plataforma podría no funcionar
          correctamente.
        </li>
        <li>
          <b>Medidas de seguridad.</b> FELVORA aplica medidas administrativas, técnicas y físicas
          para proteger sus datos, entre ellas: cifrado de los documentos almacenados, control de
          acceso por roles, separación de la información de cada entidad, verificación en dos
          pasos y bitácora de acciones.
        </li>
        <li>
          <b>Conservación.</b> Conservamos sus datos mientras dure la relación contractual y
          durante los plazos que exijan las disposiciones legales y fiscales aplicables.
          Concluidos esos plazos, los bloqueamos y después los suprimimos.
        </li>
      </ul>

      <h2 className="mt-6 font-heading text-base font-semibold text-slate-900">
        8. Cambios al aviso y consentimiento
      </h2>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        FELVORA puede modificar este aviso por cambios legales, en sus servicios o en sus
        prácticas de privacidad. Publicaremos la versión vigente en la plataforma, con su fecha
        de actualización, y le pediremos aceptarla nuevamente cuando el cambio afecte las
        finalidades o las transferencias.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Al marcar la casilla "He leído y acepto el Aviso de Privacidad", usted otorga su
        consentimiento expreso para el tratamiento de sus datos personales, incluidos los
        fiscales y patrimoniales, en los términos de este aviso. FELVORA conserva la constancia
        de su aceptación con la fecha, la hora y la versión del aviso aceptada.
      </p>
      <p className="mt-2 text-sm leading-relaxed text-slate-700">
        Si considera que su derecho a la protección de datos personales ha sido vulnerado, puede
        acudir ante la autoridad competente en la materia.
      </p>

      <p className="mt-6 text-sm font-medium text-slate-800" data-testid="aviso-fecha-actualizacion">
        Última actualización: 16 de octubre de 2026.
      </p>
    </LegalPageShell>
  );
}
